import { render, staticRenderFns } from "./imageEdit.template.vue?vue&type=template&id=296544fc&scoped=true&"
var script = {}
import style0 from "./imageEdit.template.vue?vue&type=style&index=0&id=296544fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296544fc",
  null
  
)

export default component.exports